<template>
	<div class="vesupplierAdd">
		<el-card>
			<div class="jump-btn">
				<el-button type="primary" @click="back">{{$t('lang.venue.btn_back_venue_management')}}</el-button>
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="wid100"
				:label-width="require('@/config/enum').c_ws6" :label-suffix="require('@/config/enum').c_colon">
				<el-form-item label="供应商名称" prop="supplierName">
					<el-input v-model="ruleForm.supplierName" placeholder="请输入供应商名称" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="供应商类型" prop="supplierGenre">
					<el-select v-model="ruleForm.supplierGenre" placeholder="请选择供应商分类">
						<el-option v-for="(item, index) in supplierGenreList" :key="index" :value="item.value" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="供应商类别" prop="supplierType">
					<el-select v-model="ruleForm.supplierType" placeholder="请选择供应商分类">
						<el-option v-for="(item, index) in supplierTypeList" :key="index" :value="item.value" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="业务类型" prop="businessType">
					<el-select v-model="ruleForm.businessType" placeholder="请选择业务类型">
						<el-option v-for="(item, index) in businessTypeList" :key="index" :value="item.value" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="负责人姓名" prop="contactName">
					<el-input v-model="ruleForm.contactName" :placeholder="$t('lang.venue.tip_input_contactName')"
						class="item-input" maxlength="24"></el-input>
				</el-form-item>
				<el-form-item label="负责人电话" prop="contactNumber">
					<el-input v-model="ruleForm.contactNumber" :placeholder="$t('lang.venue.tip_input_contactNumber')"
						class="item-input" maxlength="11"></el-input>
				</el-form-item>
				<el-form-item label="商家地址" prop="supplierAddress">
					<el-input v-model="ruleForm.supplierAddress" placeholder="请输入商家地址" class="item-input">
					</el-input>
				</el-form-item>
				<el-form-item label="通讯地址" prop="supplierMailAddress">
					<el-input v-model="ruleForm.supplierMailAddress" placeholder="请输入通讯地址" class="item-input">
					</el-input>
				</el-form-item>
				<el-form-item label="营业执照" prop="fileList">
					<upload-morefile ref="uploading" :fileList='filesList' upTypes='1' :clears='clears'
						@outputFile="getFile" @removeFile='removeFile'></upload-morefile>
				</el-form-item>
				<el-form-item label="税务登记证" prop="fileList1">
					<upload-morefile ref="uploading" :fileList='filesList1' upTypes='1' :clears='clears'
						@outputFile="getFile1" @removeFile='removeFile1'></upload-morefile>
				</el-form-item>
				<el-form-item label="商家简介" prop="remark">
					<el-input v-model="ruleForm.remark" :placeholder="$t('lang.venue.tip_input_remark')" class="item-input">
					</el-input>
				</el-form-item>
				<el-button class="detailbtn" type="primary" @click="save()" :disabled="isDisabled && isDisabled2">
					{{$t('lang.btn_save')}}</el-button>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import uploadmoreFile from '../../components/upload_morefile.vue'
	export default {
		data() {
			const isPhone = (rule, value, callback) => {
				let phone = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
				let telePhone = /^0[1|2|3|4|5|6|7|8|9][1|2|3|4|5|6|7|8|9][1|2|3|4|5|6|7|8|9]-\d{8}$/
				if (value === 0 || phone.test(value) || telePhone.test(value)) {
					callback()
				} else {
					callback(
						new Error(this.$i18n.t('lang.lab_inputDutyPersonPhoneIsTrue'))
					)
				}
			}
			const isImage = (rule, value, callback) => {
				if (this.ruleForm.fileList == '' || this.ruleForm.fileList == []) {
					callback(new Error(this.$i18n.t('lang.lab_pleaseSeletcUploadDoc')))
				} else {
					callback()
				}
			}
			const isImage1 = (rule, value, callback) => {
				if (this.fileList1 == '' || this.fileList1 == []) {
					callback(new Error(this.$i18n.t('lang.lab_pleaseSeletcUploadDoc')))
				} else {
					callback()
				}
			}
			return {
				clears: false,
				accept: '.jpg, .jpeg, .png',
				zero: 0, // 值为0的变量
				ruleForm: {
					id: '',
					supplierName: '',
					supplierGenre: '',
					supplierType: '',
					businessType: '',
					contactName: '',
					contactNumber: '',
					supplierAddress: '',
					supplierMailAddress: '',
					remark: '',
				},
				fileList: [],
				filesList: [],
				fileList1: [],
				filesList1: [],
				rules: {
					supplierName: [{
						required: true,
						message: '请输入供应商名称',
						trigger: 'blur'
					}],
					supplierGenre: [{
						required: true,
						message: '请选择供应商类型',
						trigger: 'change'
					}],
					// businessType: [{
					// 	required: true,
					// 	message: '请选择业务类型',
					// 	trigger: 'change'
					// }],
					// contactName: [{
					// 	required: true,
					// 	message: '请输入供应商负责人姓名',
					// 	trigger: 'blur'
					// }],
					// contactNumber: [{
					// 	required: true,
					// 	validator: isPhone,
					// 	trigger: 'blur'
					// }],
					// supplierMailAddress: [{
					// 	required: true,
					// 	message: '请输入通讯地址',
					// 	trigger: 'blur'
					// }],
					// fileList: [{
					// 	required: true,
					// 	validator: isImage,
					// 	trigger: 'blur'
					// }],
					// fileList1: [{
					// 	required: true,
					// 	validator: isImage1,
					// 	trigger: 'blur'
					// }],
				},
				supplierTypeList: [{
					value: '1',
					name: '代理'
				}, {
					value: '2',
					name: '直营'
				}],
				supplierGenreList: [{
					value: '1',
					name: '企业'
				}, {
					value: '2',
					name: '个体户'
				}],
				businessTypeList: [{
					value: '1',
					name: '用房租赁'
				}, {
					value: '2',
					name: '信号基站'
				}, {
					value: '3',
					name: '网络接入'
				}, {
					value: '4',
					name: '快递柜'
				}, {
					value: '5',
					name: '售货机'
				}, {
					value: '6',
					name: '商业摆展'
				}, {
					value: '7',
					name: '废品收回'
				}, {
					value: '8',
					name: '电梯广告'
				}, {
					value: '9',
					name: '道闸广告'
				}, {
					value: '10',
					name: '行人门广告'
				}, {
					value: '11',
					name: '灯箱广告'
				}, {
					value: '12',
					name: '转售能源'
				}, {
					value: '13',
					name: '代收缴服务'
				}, {
					value: '14',
					name: '场地类其他'
				}, {
					value: '15',
					name: '美邻商城'
				}],
				saveData: '',
				isDisabled: true, // 保存的可点击,
				isDisabled2: true // 保存的可点击
			}
		},
		components: {
			'upload-morefile': uploadmoreFile
		},
		destroyed() {
			window.localStorage.setItem('vesupplierForm', JSON.stringify(this.ruleForm))
		},
		created() {
			this.isAdd = this.$route.query.flag
			if (window.localStorage.getItem('vesupplierForm')) {
				this.ruleForm = JSON.parse(window.localStorage.getItem('vesupplierForm'))
			} else {
				if (!this.$route.query.flag) {
					console.log('编辑')
					this.getData()
				} else {
					console.log('新增')
				}
			}
		},
		watch: {
			ruleForm: {
				handler(newVal, oldVal) {
					console.log(newVal)
					console.log(this.saveData)
					// ruleForm数据变化时 会调用此方法
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.saveData) {
						// 没变
						this.isDisabled = true
					} else {
						// 变了
						this.isDisabled = false
					}
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			// 返回
			back() {
				this.$router.push({
					name: 'vesupplierList'
				})
			},
			getData() {
				console.log('object', this.$route.query.object)
				this.ruleForm.id = this.$route.query.object.id
				this.ruleForm.supplierName = this.$route.query.object.supplierName
				this.ruleForm.supplierGenre = this.$route.query.object.supplierGenre
				this.ruleForm.supplierType = this.$route.query.object.supplierType
				this.ruleForm.businessType = this.$route.query.object.businessType
				this.ruleForm.contactName = this.$route.query.object.contactName
				this.ruleForm.contactNumber = this.$route.query.object.contactNumber
				this.ruleForm.supplierAddress = this.$route.query.object.supplierAddress
				this.ruleForm.supplierMailAddress = this.$route.query.object.supplierMailAddress
				this.ruleForm.remark = this.$route.query.object.remark
				if (this.$route.query.object.photoUrlsList) {
					let list = this.$route.query.object.photoUrlsList
					let arr = []
					for (let i = 0; i < list.length; i++) {
						arr.push({
							name: '',
							url: list[i]
						})
						this.filesList = arr
						this.fileList = arr
					}
					console.log('res : ' + JSON.stringify(this.filesList))
				} else {
					this.filesList = []
					this.fileList = []
				}
				if (this.$route.query.object.photoUrlsList1) {
					let list1 = this.$route.query.object.photoUrlsList1
					let arr1 = []
					for (let i = 0; i < list1.length; i++) {
						arr1.push({
							name: '',
							url: list1[i]
						})

						this.filesList1 = arr1
						this.fileList1 = arr1
					}
					console.log('res : ' + JSON.stringify(this.filesList1))
				} else {
					this.filesList1 = []
					this.fileList1 = []
				}
				// 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
				this.saveData = JSON.stringify(this.ruleForm)
				console.log(this.saveData)
			},
			save() {
				this.$refs['ruleForm'].validate(valid => {
					if (valid) {
						this.filesList = []
						this.filesList1 = []
						if (this.fileList.length > 0) {
							for (let i = 0; i < this.fileList.length; i++) {
								this.filesList.push(this.fileList[i].url)
							}
						}
						if (this.fileList1.length > 0) {
							for (let i = 0; i < this.fileList1.length; i++) {
								this.filesList1.push(this.fileList1[i].url)
							}
						}
						if (this.isAdd) {
							let params = {
								gardenId: this.$store.getters.gardenId,
								supplierName: this.ruleForm.supplierName,
								supplierGenre: this.ruleForm.supplierGenre,
								supplierType: this.ruleForm.supplierType,
								businessType: this.ruleForm.businessType,
								contactName: this.ruleForm.contactName,
								contactNumber: this.ruleForm.contactNumber,
								supplierAddress: this.ruleForm.supplierAddress,
								supplierMailAddress: this.ruleForm.supplierMailAddress,
								filesList: this.filesList.toString(),
								filesList1: this.filesList1.toString(),
								remark: this.ruleForm.remark,
							}
							console.log(params)
							let loading = this.$loading()
							this.$post(`/venueSupplier`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										var index = this.$keepAlive.indexOf('/manage/main.vesupplierList')
										if (index > -1) {
											this.$keepAlive.splice(index, 1)
										}
										this.back()
									} else if (res && res.errCode != 0) {
										this.$message.error(res.errMsg)
									}
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							let loading = this.$loading()
							let params = {
								gardenId: this.$store.getters.gardenId,
								supplierName: this.ruleForm.supplierName,
								supplierGenre: this.ruleForm.supplierGenre,
								supplierType: this.ruleForm.supplierType,
								businessType: this.ruleForm.businessType,
								contactName: this.ruleForm.contactName,
								contactNumber: this.ruleForm.contactNumber,
								supplierAddress: this.ruleForm.supplierAddress,
								supplierMailAddress: this.ruleForm.supplierMailAddress,
								filesList: this.filesList.toString(),
								filesList1: this.filesList1.toString(),
								remark: this.ruleForm.remark,
							}
							this.$patch(`/venueSupplier/` + this.ruleForm.id, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										var index = this.$keepAlive.indexOf('/manage/main.vesupplierList')
										if (index > -1) {
											this.$keepAlive.splice(index, 1)
										}
										this.back()
									} else if (res && res.errCode != 0) {
										this.$message.error(res.errMsg)
									}
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						}
					}
				})
			},
			// 获取组件值
			getFile(e) {
				console.log(e)
				var that = this
				setTimeout(() => {
					that.fileList.push({
						name: '',
						url: e
					})
					console.log(that.fileList)
					that.isDisabled = false
				}, 1)
			},
			// 移除图片
			removeFile(e) {
				this.isDisabled = false
				let list1 = []
				for (let i = 0; i < this.fileList.length; i++) {
					if (this.fileList[i].url === e) {

					} else {
						list1.push(this.fileList[i])
					}
				}
				this.fileList = list1
			},
			// 获取组件值
			getFile1(e) {
				console.log(e)
				var that = this
				setTimeout(() => {
					that.fileList1.push({
						name: '',
						url: e
					})
					console.log(that.fileList1)
					that.isDisabled = false
				}, 1)
			},
			// 移除图片
			removeFile1(e) {
				this.isDisabled = false
				let list1 = []
				for (let i = 0; i < this.fileList1.length; i++) {
					if (this.fileList1[i].url === e) {

					} else {
						list1.push(this.fileList1[i])
					}
				}
				this.fileList1 = list1
			}
		}
	}
</script>

<style lang="scss">
	.vesupplierAdd {
		.item-input {
			width: 30%;
		}
	}
</style>